// extracted by mini-css-extract-plugin
export default {"container":"styles_container__bimkc","title":"styles_title__994SC","table":"styles_table__0CPbD","removeRow":"styles_removeRow__GAybn"};